import { HTTPClient } from '../../../shared/modules/infrastructure/HTTPClient';

export const cocheYaHttpClient = new HTTPClient({ baseUrl: '/api' });
